/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Convert_As_Web_PageInputs */

const en_mobile_convert_as_web_page = /** @type {(inputs: Mobile_Convert_As_Web_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert as web page`)
};

const es_mobile_convert_as_web_page = /** @type {(inputs: Mobile_Convert_As_Web_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir como página web`)
};

/**
* | output |
* | --- |
* | "Convert as web page" |
*
* @param {Mobile_Convert_As_Web_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_convert_as_web_page = /** @type {((inputs?: Mobile_Convert_As_Web_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Convert_As_Web_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_convert_as_web_page(inputs)
	return en_mobile_convert_as_web_page(inputs)
});